import React, { useContext, useState, useEffect } from "react";
import { DContext } from "../../../context/Datacontext";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export const Experience = () => {
    const { BeURL, instructor, setInstructor , showAlert } = useContext(DContext);
    const navigate = useNavigate()

    const [experience, setExperience] = useState([
        {
            company: "",
            role: "",
            years: "",
            description: "",
        },
    ]);

    const [loading, setLoading] = useState(false);

    //Load existing instructor experience
    useEffect(() => {
        if (instructor?.experience?.length > 0) {
            setExperience(instructor.experience);
        }
    }, [instructor]);

    // ================= ADD =================
    const addExperience = () => {
        setExperience([
            ...experience,
            { company: "", role: "", years: "", description: "" },
        ]);
    };

    // ================= REMOVE =================
    const removeExperience = (index) => {
        const updated = [...experience];
        updated.splice(index, 1);

        if (updated.length === 0) {
            updated.push({
                company: "",
                role: "",
                years: "",
                description: "",
            });
        }

        setExperience(updated);
    };

    // ================= CHANGE =================
    const handleChange = (index, e) => {
        const updated = [...experience];
        updated[index][e.target.name] = e.target.value;
        setExperience(updated);
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const res = await fetch(
                `${BeURL}/update/instructor/profile/experience`,
                {
                    method: "PUT",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ experience }),
                }
            );

            if (!res.ok) {
                throw new Error("Server Error");
            }

            const data = await res.json();

            if (data.success) {
                showAlert("Experience created successfully");
                navigate("/instructor/my/education")
                setInstructor(data.updatedInstructor); // update context
            } else {
                alert(data.message || "Update failed");
            }
        } catch (err) {
            console.error("Experience Update Error:", err);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-5xl bg-white p-6 rounded-xl shadow-sm">
            {/* HEADER */}
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-semibold text-gray-800">
                    Professional Experience
                </h2>

                <button
                    type="button"
                    onClick={addExperience}
                    className="flex items-center gap-2 text-primary-600 font-semibold px-4 py-2 rounded-lg transition"
                >
                    <FiPlus />
                    Add
                </button>
            </div>

            {/* FORM */}
            <form onSubmit={handleSubmit} className="space-y-6">
                {experience.map((exp, index) => (
                    <div
                        key={index}
                        className="border rounded-xl p-5 bg-gray-50 shadow-sm space-y-4"
                    >
                        {/* GRID */}
                        <div className="grid sm:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="company"
                                placeholder="Company Name"
                                value={exp.company}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />

                            <input
                                type="text"
                                name="role"
                                placeholder="Role / Position"
                                value={exp.role}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />

                            <input
                                type="text"
                                name="years"
                                placeholder="Years (Ex: 2022 - 2024)"
                                value={exp.years}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg sm:col-span-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* DESCRIPTION */}
                        <textarea
                            name="description"
                            rows="3"
                            placeholder="Describe your responsibilities and achievements..."
                            value={exp.description}
                            onChange={(e) => handleChange(index, e)}
                            className="w-full border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />

                        {/* REMOVE BUTTON */}
                        {experience.length > 1 && (
                            <div className="flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => removeExperience(index)}
                                    className="flex items-center gap-2 text-red-500 hover:text-red-600 text-sm"
                                >
                                    <FiTrash2 />
                                    Remove
                                </button>
                            </div>
                        )}
                    </div>
                ))}

                {/* SAVE BUTTON */}
                <div className="flex justify-end">
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-lg transition disabled:opacity-50"
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>
            </form>
        </div>
    );
};
